module.exports = __webpack_public_path__ + "img/1483041931.dbecac8c.jpg";